export const OnLoadData = () => {
    const defaultOnload = {
        onLoad:
            ` async function main() {
                // Start of editable area
            //     const option = {
            //         xAxis: {
            //             type: 'category',
            //             data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
            //         },
            //         yAxis: {
            //             type: 'value'
            //         },
            //         series: [
            //             {
            //                 data: [120, 200, 150, 80, 70, 110, 130],
            //                 type: 'bar'
            //             }
            //         ]
            //     };
            //  return option
             // End of editable area
                 }`
        ,
        onLoad2:
            ` async function main() {
                // Start of editable area
                //const option = {
                    // xAxis: {
                    //   type: 'category',
                    //   data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                    // },
                    // yAxis: {
                    //   type: 'value'
                    // },
                    // series: [
                    //   {
                    //     data: [120, 200, 150, 80, 70, 110, 130],
                    //     type: 'bar',
                    //     showBackground: true,
                    //     backgroundStyle: {
                    //       color: 'rgba(180, 180, 180, 0.2)'
                    //     }
                    //   }
                    // ]
                    //   };
                    //  return option
                 // End of editable area
                 }`,
        onLoad3: ` async function main() {
                 // Start of editable area
                     // const option = {
                     //     tooltip: {
                     //       trigger: 'axis',
                     //       axisPointer: {
                     //         type: 'shadow'
                     //       }
                     //     },
                     //     grid: {
                     //       left: '3%',
                     //       right: '4%',
                     //       bottom: '3%',
                     //       containLabel: true
                     //     },
                     //     xAxis: [
                     //       {
                     //         type: 'category',
                     //         data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                     //         axisTick: {
                     //           alignWithLabel: true
                     //         }
                     //       }
                     //     ],
                     //     yAxis: [
                     //       {
                     //         type: 'value'
                     //       }
                     //     ],
                     //     series: [
                     //       {
                     //         name: 'Direct',
                     //         type: 'bar',
                     //         barWidth: '60%',
                     //         data: [10, 52, 200, 334, 390, 330, 220]
                     //       }
                     //     ]
                     //   };
                     //  return option
                // End of editable area
                      }`,
        onLoad4: ` async function main() {
                    // Start of editable area
                    // const option = {
                    //     xAxis: {
                    //       type: 'category',
                    //       data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                    //     },
                    //     yAxis: {
                    //       type: 'value'
                    //     },
                    //     series: [
                    //       {
                    //         data: [
                    //           120,
                    //           {
                    //             value: 200,
                    //             itemStyle: {
                    //               color: '#a90000'
                    //             }
                    //           },
                    //           150,
                    //           80,
                    //           70,
                    //           110,
                    //           130
                    //         ],
                    //         type: 'bar'
                    //       }
                    //     ]
                    //   };
                    //  return option
                // End of editable area
                    }`,
        onLoad5:
            ` async function main() {
                    // Start of editable area
                    // const option = { 
                    //     tooltip: {
                    //       trigger: 'axis',
                    //       axisPointer: {
                    //         type: 'shadow'
                    //       },
                    //       formatter: function (params) {
                    //         var tar = params[1];
                    //         return tar.name + '<br/>' + tar.seriesName + ' : ' + tar.value;
                    //       }
                    //     },
                    //     grid: {
                    //       left: '3%',
                    //       right: '4%',
                    //       bottom: '3%',
                    //       containLabel: true
                    //     },
                    //     xAxis: {
                    //       type: 'category',
                    //       splitLine: { show: false },
                    //       data: ['Total', 'Rent', 'Utilities', 'Transportation', 'Meals', 'Other']
                    //     },
                    //     yAxis: {
                    //       type: 'value'
                    //     },
                    //     series: [
                    //       {
                    //         name: 'Placeholder',
                    //         type: 'bar',
                    //         stack: 'Total',
                    //         itemStyle: {
                    //           borderColor: 'transparent',
                    //           color: 'transparent'
                    //         },
                    //         emphasis: {
                    //           itemStyle: {
                    //             borderColor: 'transparent',
                    //             color: 'transparent'
                    //           }
                    //         },
                    //         data: [0, 1700, 1400, 1200, 300, 0]
                    //       },
                    //       {
                    //         name: 'Life Cost',
                    //         type: 'bar',
                    //         stack: 'Total',
                    //         label: {
                    //           show: true,
                    //           position: 'inside'
                    //         },
                    //         data: [2900, 1200, 300, 200, 900, 300]
                    //       }
                    //     ]
                    //   };
                    //  return option
                 // End of editable area
                    }`,
        onLoad6:
            ` async function main() {
                 // Start of editable area
                    // const labelRight = {
                    //     position: 'right'
                    //   };
                    // const option = {
                    //     tooltip: {
                    //       trigger: 'axis',
                    //       axisPointer: {
                    //         type: 'shadow'
                    //       }
                    //     },
                    //     grid: {
                    //       top: 15,
                    //     },
                    //     xAxis: {
                    //       type: 'value',
                    //   position: 'top',
                    //       splitLine: {
                    //         lineStyle: {
                    //           type: 'dashed'
                    //         }
                    //       }
                    //     },
                    //     yAxis: {
                    //       type: 'category',
                    //       axisLine: { show: false },
                    //       axisLabel: { show: false },
                    //       axisTick: { show: false },
                    //       splitLine: { show: false },
                    //       data: [
                    //         'ten',
                    //         'nine',
                    //         'eight',
                    //         'seven',
                    //         'six',
                    //         'five',
                    //         'four',
                    //         'three',
                    //         'two',
                    //         'one'
                    //       ]
                    //     },
                    //     series: [
                    //       {
                    //         name: 'Cost',
                    //         type: 'bar',
                    //         stack: 'Total',
                    //         label: {
                    //           show: true,
                    //           formatter: '{b}'
                    //         },
                    //         data: [
                    //           { value: -0.07, label: labelRight },
                    //           { value: -0.09, label: labelRight },
                    //           0.2,
                    //           0.44,
                    //           { value: -0.23, label: labelRight },
                    //           0.08,
                    //           { value: -0.17, label: labelRight },
                    //           0.47,
                    //           { value: -0.36, label: labelRight },
                    //           0.18
                    //         ]
                    //       }
                    //     ]
                    //   };
                    //  return option
                // End of editable area
                      }`,
        onLoad7:
        `
        async function main() {
            // Start of editable area
            // const option = {
            //     xAxis: {
            //         type: 'value',
            //         max: 'dataMax',
            //         // inverse: true
            //     },
            //     yAxis: {
            //         type: 'category',
            //         data: ['A', 'B', 'C', 'D', 'E'],
            //         inverse: true,
            //         animationDuration: 300,
            //         animationDurationUpdate: 300,
            //         max: 2 // only the largest 3 bars will be displayed
            //     },
            //     series: [
            //         {
            //             realtimeSort: true,
            //             name: 'X',
            //             type: 'bar',
            //             data: [2323, 2323, 2323.23, 2323, 2323],
            //             label: {
            //                 show: true,
            //                 position: 'right',
            //                 valueAnimation: true
            //             }
            //         }
            //     ],
            //     legend: {
            //         show: true
            //     },
            //     animationDuration: 0,
            //     animationDurationUpdate: 3000,
            //     animationEasing: 'linear',
            //     animationEasingUpdate: 'linear'
            // };
            // return option;
          // End of editable area
      }`,
        onLoad8:
        `
        async function main() {
            // Start of editable area
            // const option = {
                //     xAxis: {
                //       type: 'category',
                //       data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                //     },
                //     yAxis: {
                //       type: 'value'
                //     },
                //     series: [
                //       {
                //         data: [150, 230, 224, 218, 135, 147, 260],
                //         type: 'line'
                //       }
                //     ]
                //   };
            // return option;
          // End of editable area
      }`,
        onLoad9:
        `
        async function main() {
            // Start of editable area
                // const option = {
                //     tooltip: {
                //       trigger: 'axis'
                //     },
                //     legend: {
                //       data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
                //     },
                //     grid: {
                //       left: '3%',
                //       right: '4%',
                //       bottom: '3%',
                //       containLabel: true
                //     },
                //     xAxis: {
                //       type: 'category',
                //       boundaryGap: false,
                //       data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                //     },
                //     yAxis: {
                //       type: 'value'
                //     },
                //     series: [
                //       {
                //         name: 'Email',
                //         type: 'line',
                //         stack: 'Total',
                //         //smooth: true,
                //         data: [120, 132, 101, 134, 90, 230, 210],
                //         //emphasis: {
                //         //   focus: 'series'
                //         //  }, 
                //         // areaStyle: {},
                //       },
                //       {
                //         name: 'Union Ads',
                //         type: 'line',
                //         stack: 'Total',
                //         //smooth: true,
                //         data: [220, 182, 191, 234, 290, 330, 310],
                //         //emphasis: {
                //         //   focus: 'series'
                //         //  }, 
                //         // areaStyle: {},
                //       },
                //       {
                //         name: 'Video Ads',
                //         type: 'line',
                //         stack: 'Total',
                //         //smooth: true,
                //         data: [150, 232, 201, 154, 190, 330, 410],
                //         //emphasis: {
                //         //   focus: 'series'
                //         //  }, 
                //         // areaStyle: {},
                //       },
                //       {
                //         name: 'Direct',
                //         type: 'line',
                //         stack: 'Total',
                //         //smooth: true,
                //         data: [320, 332, 301, 334, 390, 330, 320],
                //         //emphasis: {
                //         //   focus: 'series'
                //         //  }, 
                //         // areaStyle: {},
                //       },
                //       {
                //         name: 'Search Engine',
                //         type: 'line',
                //         stack: 'Total',
                //         //smooth: true,
                //         data: [820, 932, 901, 934, 1290, 1330, 1320],
                //         //emphasis: {
                //         //   focus: 'series'
                //         //  }, 
                //         // areaStyle: {},
                //       }
                //     ]
                //   };
            // return option;
          // End of editable area
      }`,

    }
    return defaultOnload
}	